import { MutableRefObject, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { LicenceValue, ReactState } from '../Types/Types'
import { getLicenceValue } from '../API/Licence/LicenceAPI'
import { isStringNotEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { convertLicenceBooleanToBoolean } from '../../../NonReact/utils/LicenceUtils'

export function useLicenceFeatureFlag(key: string, defaultValue: boolean): boolean
export function useLicenceFeatureFlag(key: string, defaultValue?: undefined): Nullable<boolean>
export function useLicenceFeatureFlag(key: string, defaultValue?: boolean): Nullable<boolean> {
    const [isFeatureFlag, setIsFeatureFlag]: ReactState<Nullable<boolean>> = useState<Nullable<boolean>>(defaultValue)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    const { debug }: Console = console

    useEffect(() => {
        getLicenceValue(key)
            .then((licenceValue: Nullable<LicenceValue>): void => {
                if (isMounted.current) {
                    if (isStringNotEmpty(licenceValue?.Value)) {
                        setIsFeatureFlag(convertLicenceBooleanToBoolean(licenceValue?.Value))
                    }
                }
            })
            .catch(debug)
    }, [])

    return isFeatureFlag
}
